var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrengths(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5150",
    "data-name": "Group 5150",
    transform: "translate(-289 -644)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_231",
    "data-name": "Ellipse 231",
    transform: "translate(295 650)",
    fill: "#9169df",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 43.5,
    r: 43.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 43.5,
    r: 46.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1,
    transform: "translate(314.532 669.532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15040",
    "data-name": "Path 15040",
    d: "M46.039,47.28a14.1,14.1,0,0,1-7.363-2.063,20.906,20.906,0,0,1-9.826,2.864c-5.656,0-9.055-1.623-10.965-3.09-5.5,1.344-12.842-.212-14.485-2.447-.949-1.3-1.221-3.229-.81-5.741A18.29,18.29,0,0,1,0,27.246c0-4.172,1.5-8.748,2.96-13.172a62.109,62.109,0,0,0,2.5-9.026,2.347,2.347,0,0,1,2.084-1.96A75.713,75.713,0,0,0,21.167.172L21.407.1a2.3,2.3,0,0,1,2.451.764l2.084,2.606a2.316,2.316,0,0,1,.321,2.346l-1.672,3.9a2.9,2.9,0,0,1-2.272,4.708H15.227v2.781A7.069,7.069,0,0,0,16.5,21.316a16.546,16.546,0,0,1,1.767,3.118,17.775,17.775,0,0,1,12.181-4.4,14.841,14.841,0,0,1,7.973,2.084,13.569,13.569,0,0,1,7.253-2.084h.361a2.047,2.047,0,0,1,2.043,2.043V45.236a2.046,2.046,0,0,1-2.043,2.043Zm.441-25.2a.437.437,0,0,0-.441-.441h-.361a11.974,11.974,0,0,0-5.838,1.516,11.43,11.43,0,0,1,3.392,4.641.8.8,0,0,1-1.519.51,10.219,10.219,0,0,0-3.739-4.563,13.063,13.063,0,0,0-7.522-2.105A16.028,16.028,0,0,0,18.847,26.1a10.519,10.519,0,0,1,.386,2.751c0,5.048-1.7,6.156-2.046,6.331a.835.835,0,0,1-.372.087.8.8,0,0,1-.721-.434.781.781,0,0,1,.337-1.063c.01-.012,1.2-.849,1.2-4.919a9.028,9.028,0,0,0-.442-2.737,14.419,14.419,0,0,0-1.99-3.867,8.67,8.67,0,0,1-1.575-5.039V14.333a4.419,4.419,0,0,1-3.26-2.69l-.69-1.731a.8.8,0,0,1,1.489-.593l.688,1.729a2.828,2.828,0,0,0,2.587,1.774h7.881a1.293,1.293,0,0,0,.82-.289,1.31,1.31,0,0,0,.454-.757,1.269,1.269,0,0,0-.45-1.25l-.009-.01-.01-.006a1.267,1.267,0,0,0-.7-.287l-5.711-.481A2.02,2.02,0,0,1,14.955,7.1l.313-.938a.8.8,0,0,1,1.523.506l-.313.938a.405.405,0,0,0,.048.357.414.414,0,0,0,.316.187l1.375.115,1.1-2.209a.8.8,0,0,1,1.434.716L19.931,8.4l2.625.221a2.925,2.925,0,0,1,.688.154l1.539-3.593a.711.711,0,0,0-.1-.721l-2.079-2.6a.7.7,0,0,0-.743-.236l-.24.074a77.211,77.211,0,0,1-13.9,2.978.757.757,0,0,0-.68.623,64.348,64.348,0,0,1-2.558,9.27C3.068,18.88,1.6,23.331,1.6,27.246a16.628,16.628,0,0,0,2.5,8.963.265.265,0,0,1,.012.026A10.839,10.839,0,0,0,5.376,37.9a.8.8,0,1,1-1.133,1.133c-.01-.01-.1-.1-.228-.248A4.668,4.668,0,0,0,4.693,41.6c1.081,1.47,7.853,3.205,13.163,1.746A10.452,10.452,0,0,0,21.17,41.82a.8.8,0,1,1,.934,1.3,11.124,11.124,0,0,1-2.3,1.236,17.158,17.158,0,0,0,9.045,2.12A19.71,19.71,0,0,0,38.3,43.594a24.862,24.862,0,0,0,3.647-2.526A.8.8,0,0,1,43,42.27a24.648,24.648,0,0,1-2.736,1.993,12.5,12.5,0,0,0,5.773,1.414.436.436,0,0,0,.441-.441Z",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15041",
    "data-name": "Path 15041",
    d: "M23.93,42.308a18.619,18.619,0,0,1-4.891.654,20.047,20.047,0,0,1-9.591-2.524.847.847,0,1,1,.8-1.491c10.353,5.573,18.208-.5,18.534-.762a.846.846,0,1,1,1.056,1.323,17.528,17.528,0,0,1-5.911,2.8Z",
    transform: "translate(10.999 -7.735)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrengths);
export default __webpack_public_path__ + "static/media/Strengths.6bcd2b198c53a5684f92c7f355a04343.svg";
export { ForwardRef as ReactComponent };